// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../assets/images/svg/loading.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".infinite-loader{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");width:33px;height:34px;vertical-align:top;background-repeat:no-repeat;background-size:30px;background-position:center;-webkit-animation:rotation 2s linear infinite;animation:rotation 2s linear infinite;-webkit-transform-origin:center center;color:rgba(0,0,0,0.3);transition:transform .3s}\n", ""]);
// Exports
module.exports = exports;
